import { motion } from 'framer-motion';
import { Link as RouterLink } from 'react-router-dom';
import { styled } from '@material-ui/core/styles';
import { Box, Button, Typography, Container } from '@material-ui/core';
import { MotionContainer, varBounceIn } from '../../components/animate';
import Page from '../../components/Page';


const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10)
}));

export default function PageExpirado() {
    return (
      <RootStyle title="Link expirado | ASSEMBLEIACOOP">
        <Container className='conteudo-geral'>
          <MotionContainer initial="initial" open>
            <Box  sx={{ maxWidth: 680, margin: 'auto', textAlign: 'center' }}>
              <motion.div className='titulo-geral' variants={varBounceIn}>
                <h3>              O link expirou
                </h3>
              </motion.div>
              <Typography variant='p'>
              O link de redefinição de senha que você tentou acessar já não é válido.
              </Typography>
  
  
              <Button className='btn-cinza centraliza-btn'  to="/" size="large" variant="contained" component={RouterLink}>
               voltar para tela inicial
              </Button>
            </Box>
          </MotionContainer>
        </Container>
      </RootStyle>
    );
}
